import { ApolloError, ServerError, ServerParseError } from "@apollo/client";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { isProductionEnvironment } from "./UtilityMethods";
import { IDENTITY_BREADCRUMB } from "../App";

const sentryOptions = {
    dsn: "https://394aeea4655342eda3712abaa54f2f91@o1413791.ingest.sentry.io/6753754",
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0.0,
    maxValueLength: 1024,
};

const ENABLE_IN_DEV = false;

export const initSentry = (): void => {
    if (isProductionEnvironment() || ENABLE_IN_DEV) {
        Sentry.init(sentryOptions);
    }
};

export function logSentry(prefix: string, error: Error | ApolloError | ServerError | ServerParseError | string): void {
    if (isProductionEnvironment() || ENABLE_IN_DEV) {
        const errorMessage = typeof error === "string" ? error : error.message;
        Sentry.captureMessage(formatMessage(errorMessage, prefix), "error");
    }
}

export function logSentryError(error: Error | ApolloError | ServerError | ServerParseError): void {
    if (isProductionEnvironment() || ENABLE_IN_DEV) {
        Sentry.captureMessage(formatMessage(error.message), "error");
    }
}

export function logSentryFatal(error: Error | ApolloError | ServerError | ServerParseError): void {
    if (isProductionEnvironment() || ENABLE_IN_DEV) {
        Sentry.captureMessage(formatMessage(error.message), "fatal");
    }
}

function formatMessage(error: string, prefix = ""): string {
    const identityBreadcrumb = localStorage.getItem(IDENTITY_BREADCRUMB) ?? "no breadcrumb";
    return `(id: ${identityBreadcrumb} | ${prefix} | ${error}`;
}
